import { Text } from '../../../../components/text'

export default function Description({ description }: { description: string }) {
	return (
		<Text.HDSBody className="hds-form-radio-card__description" size="100">
			{description}
		</Text.HDSBody>
	)
}
